// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3QNco","label":"SetPasswdForm_label__1q2hL"};